import { useRef } from 'react';

/**
 * useRenderCount
 * @description Get the render count of a component
 * @see {@link https://rooks.vercel.app/docs/useRenderCount}
 */
function useRenderCount() {
    return ++useRef(0).current;
}

export { useRenderCount };
